"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGamification = void 0;
const gamification_1 = require("../../enums/gamification");
const constant_1 = require("../constant");
exports.defaultGamification = {
    gameCenterId: '',
    status: gamification_1.GamificationStatus.DRAFT,
    adventureFlows: constant_1.emptyArrayForDynamo,
    attemptGameTable: constant_1.emptyArrayForDynamo,
    attemptConditions: constant_1.emptyArrayForDynamo,
    coinCondition: null,
    rewardPopUpText: '',
    rewardTable: constant_1.emptyArrayForDynamo,
    rewardCondition: null,
};
